/* eslint-disable no-nested-ternary */
import { Card, Stack } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getWeekdayOccurrence } from "utils/Date";
import CompetitionActions from "./CompetitionActions";

const repeatOnOptions = ["S", "M", "T", "W", "T", "F", "S"];

function CompetitionCard({
  competition,
  selectedTab,
  handleCompetitionEnd,
  handleCompetitionDelete,
  setCompetition,
  setIsRunCompetitionModalOpen,
  setIsParticipantModalOpen,
  handleCompetitionActivate,
  removeCompetitionFromFavorites,
  showActions = true,
}) {
  const [controller] = useMaterialUIController();
  const loginUser = useSelector((state) => state.loginUser.loginUserState);
  const { darkMode } = controller;
  const [days, setDays] = useState();
  const [hours, setHours] = useState();
  const [minutes, setMinutes] = useState();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (competition.status === "running" && competition?.endDatetime) {
      const interval = setInterval(() => {
        const then = moment.tz(competition.endDatetime, loginUser.timezone);
        const now = moment.tz(undefined, loginUser.timezone);
        const countdown = moment.duration(then.diff(now));
        const daysValue = countdown.days();
        const hoursValue = countdown.hours();
        const minutesValue = countdown.minutes();
        setDays(daysValue);
        setHours(hoursValue);
        setMinutes(minutesValue);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        height: "100%",
        justifyContent: "center",
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          "& .MuiTypography-caption": { fontSize: "0.80rem" },
          img: {
            height: "30px",
            width: "30px",
          },
        }}
        justifyContent="space-between"
      >
        <Stack spacing={1.2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <img src={competition?.Badge?.badgeUrl} alt="badge" height="25px" width="25px" />
            <MDTypography variant="h5" component="h5">
              {competition?.name}
            </MDTypography>
          </Stack>
          {(selectedTab === 0 || selectedTab === 1) && (
            <MDTypography variant="caption" component="h6">
              {`${!competition.endDatetime ? "Start Time " : ""}${moment
                .tz(competition.startDatetime, loginUser.timezone)
                .format("MM/DD/YYYY hh:mm A")}`}
              {competition.endDatetime
                ? ` -
              ${moment
                .tz(competition.endDatetime, loginUser.timezone)
                .format("MM/DD/YYYY hh:mm A")}`
                : null}
            </MDTypography>
          )}
          {competition?.repeatCompetition ? (
            <MDTypography variant="caption" component="h6">
              {competition?.repeatInterval !== "custom"
                ? `Set to repeat ${competition.repeatInterval}`
                : `Set to repeat: every ${
                    competition.repeatEveryCount > 1 ? competition.repeatEveryCount : ""
                  } ${
                    competition.repeatEveryType === "week"
                      ? `${competition.repeatEveryType} (${[...(competition?.repeatOn || [])]
                          .map((c, i) => (c === "1" ? repeatOnOptions[i] : "-"))
                          .join("")})`
                      : competition.repeatEveryType === "month"
                      ? `${competition.repeatEveryType} (${
                          competition?.repeatOn === "byDate"
                            ? `on day ${moment
                                .tz(competition?.startDatetime, competition?.timezone)
                                .format("D")}`
                            : `on the ${getWeekdayOccurrence(
                                competition?.startDatetime,
                                competition?.timezone,
                                competition?.repeatOn
                              )}`
                        })`
                      : competition.repeatEveryType
                  } ${
                    competition?.repeatEnds !== "never"
                      ? `till ${
                          competition?.repeatEnds === "on"
                            ? moment
                                .tz(competition.repeatEndsOn, loginUser.timezone)
                                .format("MM/DD/YYYY")
                            : `${competition?.occurrences || 0} occurrences`
                        }`
                      : ""
                  }`}
            </MDTypography>
          ) : null}
          {selectedTab === 0 ? (
            competition?.status === "running" ? (
              <>
                <MDTypography variant="caption" component="h6">
                  In Progress
                </MDTypography>
                {competition?.endDatetime && (
                  <MDTypography variant="caption" component="h6">
                    Time Remaining: {days > 0 ? days : 0} {days > 1 ? "days" : "day"},{" "}
                    {hours > 0 ? hours : 0} {hours > 1 ? "Hours" : "Hour"},{" "}
                    {minutes > 0 ? minutes : 0} {minutes > 1 ? "minutes" : "minute"}
                  </MDTypography>
                )}
              </>
            ) : competition?.status === "closed" ? (
              <MDTypography variant="caption" component="h6">
                Closed
              </MDTypography>
            ) : (
              <MDTypography variant="caption" component="h6">
                Upcoming
              </MDTypography>
            )
          ) : null}
          <MDTypography
            variant="caption"
            component="h6"
            style={{ color: darkMode ? "white" : "rgba(0, 0, 0, 0.87)" }}
          >
            {competition.description}
          </MDTypography>
        </Stack>
        {showActions && (
          <Stack justifyContent="end">
            <CompetitionActions
              competition={competition}
              selectedTab={selectedTab}
              setCompetition={setCompetition}
              endCompetition={handleCompetitionEnd}
              deleteCompetition={handleCompetitionDelete}
              setIsRunCompetitionModalOpen={setIsRunCompetitionModalOpen}
              setIsParticipantModalOpen={setIsParticipantModalOpen}
              activateCompetition={handleCompetitionActivate}
              removeCompetitionFromFavorites={removeCompetitionFromFavorites}
            />
          </Stack>
        )}
      </Stack>
    </Card>
  );
}

export default CompetitionCard;
